import { ChangeDetectorRef, inject, signal } from '@angular/core';
import { AppStateService, HttpErrorService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';
import { GetCustomerStationRateDto, Station, StationRate, StationTime } from '../../../models';

/** when extending this class be sure to implement ngOnInit,
 * @Input() 
 * override getRate = false;
 * 
 * @Input() 
 * override calculateDuration = false;
 */
export class NgxAimStationSelectTime {
  // ngOnInit() {
  //   this.init();
  // }

  getRate = true;
  calculateDuration = true;

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  appStateService = inject(AppStateService);
  router = inject(Router);
  changeRef = inject(ChangeDetectorRef);

  isLoading = signal(true);
  routes = PublicRoutes;
  selectedGroup = this.stationsService.getSelectedGroup();
  selectedStation = this.stationsService.getSelectedStation();
  times: StationTime[] = [];
  selectedTime = this.stationsService.getSelectedTime();
  rate: StationRate = {
    Id: 0,
    Rate: 0,
    Unit: 0,
    Grace: 0,
    MinTime: 0,
    Description: '',
    Source: '',
    Category: 0,
  }

  init() {
    if (this.selectedGroup) {
      this.findAllStations(this.selectedGroup.Id);
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS]);
    }
  }

  findAllStations(groupId: number) {
    this.isLoading.set(true);
    this.stationsService.findAllStations(groupId, true).subscribe({
      next: (stations) => this.onStationsSuccess(stations),
      error: (err) => this.onStationsError(err),
    });
  }

  onStationsSuccess(stations: Station[]) {
    this.isLoading.set(false);
    if (this.selectedStation) {
      const selectedStation = stations.find((station) => station.Id === this.selectedStation!.Id);
      if (selectedStation) {
        this.selectedStation = selectedStation;
        this.stationsService.setSelectedStation(selectedStation);
        if (this.getRate) {
          this.getStationRate();
        } else {
          this.setTimes();
        }
      }
    }
  }

  setTimes() {
    let allDayTime: StationTime | null = null;

    let rate = this.rate.Rate;
    if (this.rate.Unit !== 0) {
      rate = this.rate.Rate * (this.selectedGroup!.Interval / this.rate.Unit);
    }

    this.selectedStation?.AvailabilityCalendar.forEach((time, i) => {
      const [startHours, startMinutes] = time.split('T')[1].split(':');
      const startMeridian = startHours >= '12' ? 'PM' : 'AM';
      const startHours12 = +startHours % 12 || 12;
      const startDate = new Date(time);

      const endDate = new Date(startDate.getTime() + this.selectedGroup!.Interval * 60_000);
      const endDateString = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }).format(endDate);

      if (this.selectedStation?.OpenRange) {
        this.times.push({
          time,
          formatedTimeAndRate: `${startHours12}:${startMinutes} ${startMeridian} ($${rate})`,
          index: i,
        });
      } else {
        this.times.push({
          time,
          formatedTimeAndRate: `${startHours12}:${startMinutes} ${startMeridian} — ${endDateString} ($${rate})`,
          index: i,
        });
      }


      if (i === 0 && this.selectedStation?.AvailabilityCalendar.length === 2 && this.stationsService.addButtonForAllDay) {
        allDayTime = {
          time,
          formatedTimeAndRate: `All Day ($${rate * 2})`,
          index: 2,
        }
      }
    });

    if (allDayTime) {
      this.times.push(allDayTime);
    }

    const selectedFormatedTime = this.times.find((time) => time.formatedTimeAndRate === this.selectedTime?.formatedTimeAndRate);
    if (selectedFormatedTime) {
      this.selectedTime = selectedFormatedTime;
    }
    this.changeRef.detectChanges();
  }

  onStationsError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load stations');
  }

  onTimeClick(time: StationTime) {
    const selectedTime = this.times.find((t) => t.formatedTimeAndRate === time.formatedTimeAndRate);
    if (selectedTime) {
      this.selectedTime = selectedTime;
      this.stationsService.setSelectedTime(selectedTime);
    }

    if (this.calculateDuration) {
      let duration = 0;
      if (time.index === 2 && this.stationsService.addButtonForAllDay) {
        duration = this.selectedGroup!.Interval * 2;
      } else {
        duration = this.selectedGroup!.Interval;
      }

      this.stationsService.setSelectedDuration(duration);
    }
  }

  getStationRate() {
    this.isLoading.set(true);
    const dto: GetCustomerStationRateDto = {
      StationId: this.selectedStation!.Id,
    }
    this.stationsService.getRate(dto).subscribe({
      next: (res) => this.getRateSuccess(res),
      error: (err) => this.onGetRateError(err),
    });
  }

  getRateSuccess(res: StationRate) {
    this.isLoading.set(false);
    this.rate = res;
    this.stationsService.setSelectedRate(res);
    this.setTimes();
  }

  onGetRateError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load rates');
  }

  onNextClick() {
    if (this.stationsService.stationHasTerms) {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id, this.routes.TERMS]);
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id, this.routes.OVERVIEW]);
    }
  }

  onBackClick() {
    if (this.stationsService.skipDurationSelect) {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id]);
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id, this.routes.SELECT_DURATION]);
    }
  }
}